import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Button from '@material-ui/core/Button';
import sanitizeRestProps from './sanitizeRestProps';

const LatLngField = (props) => {
  const [clicked, setClicked] = useState(false);

  const { className, classes = {}, record, prefix = '', ...rest } = props;

  const latValue = get(record, `${prefix}lat`);
  const lngValue = get(record, `${prefix}lng`);
  if (!latValue || !lngValue) {
    return <div className={className} {...sanitizeRestProps(rest)} />;
  }

  const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const imgUrlPrefix = `https://maps.googleapis.com/maps/api/staticmap?key=${googleApiKey}&size=200x200&maptype=satellite&zoom=17`;
  const markers = [`&markers=color%3Agreen|${latValue}%2C${lngValue}`];
  const fullImgUrl = `${imgUrlPrefix}&${markers.join('&')}`;

  const externalUrl = `https://maps.google.com/maps?t=k&q=loc:${latValue}%2C${lngValue}`;

  const title = `${latValue},\n${lngValue}`;

  const handleClick = (event) => {
    event.stopPropagation();
    setClicked(true);
  };

  return (
    <div className={className} {...sanitizeRestProps(rest)}>
      {clicked ? (
        <a href={externalUrl} target="_blank" rel="noopener noreferrer">
          <img
            title={title}
            alt={title}
            src={fullImgUrl}
            className={classes.image}
            style={{ maxWidth: '200px' }}
          />
        </a>
      ) : (
        <Button onClick={handleClick}>View Google Map</Button>
      )}
      {title}
    </div>
  );
};

LatLngField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
};

LatLngField.defaultProps = {
  classes: {},
  label: 'Lat/Lng',
  className: '',
  record: {},
  title: '',
};

export default LatLngField;
